import Select, { SelectContent, SelectItem, SelectTrigger, SelectValue } from '@cobliteam/ui/form/Select';

type Position = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'bottom-center' | 'top-center';

interface PositionDataProps {
  position: Position;
  onPositionChange: (position: Position) => void;
}

const POSITION_OPTIONS: { value: Position; label: string }[] = [
  { value: 'top-left', label: 'Top Left' },
  { value: 'top-center', label: 'Top Center' },
  { value: 'top-right', label: 'Top Right' },
  { value: 'bottom-left', label: 'Bottom Left' },
  { value: 'bottom-center', label: 'Bottom Center' },
  { value: 'bottom-right', label: 'Bottom Right' },
];

const PositionData = ({ position, onPositionChange }: PositionDataProps) => {
  return (
    <Select value={position} onValueChange={onPositionChange}>
      <SelectTrigger size='sm'>
        <SelectValue placeholder='position' />
      </SelectTrigger>
      <SelectContent>
        {POSITION_OPTIONS.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default PositionData;
